import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { customerSession } from './CustomerSession';

const body = z
    .object({
        url: z.string().url(),
        referrer: z.string()
    })
    .strict();

export const createCustomerSession = {
    verb: 'post',
    path: 'create',
    schema: {
        body,
        response: {
            200: customerSession.strict()
        }
    }
} as const satisfies EndpointContract;
